export default __webpack_public_path__ + "static/media/xlsx.dc8c42f6.svg";